import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { heicKey, MAX_RAW_IMAGE_SIZE_MB } from 'util/image'
import css from './Blank.module.scss'

export const Blank = observer(() => {
  return (
    <Vertical center>
      <Space height={48} />
      <Space className={css.dash} center>
        <Icon name="add" size={24} />
      </Space>
      <Space pad={[12, 0]} height={64} top>
        <Typo size={11} line={1.2} pre>
          {i18n(heicKey('upload.ImageRequirements'), { count: MAX_RAW_IMAGE_SIZE_MB })}
        </Typo>
      </Space>
    </Vertical>
  )
})
